import axios from "axios";
import store from "@/store";

let baseURL = "https://wx-platform.engma.net/intec/";
const baseAxios = axios.create({
    baseURL : baseURL,
});
baseAxios.interceptors.request.use((config) => {
    const utoken = store.state.openid;
    if (utoken) {
        config.headers["openId"] = utoken; // 让每个请求携带自定义 token 请根据实际情况自行修改
    }
    return config;
});
baseAxios.interceptors.response.use((res) => {
  return res.data;
});

export default baseAxios;
